
import "./funderComponents.css";

// Recharts uses real CSS colors — we mirror the design tokens from index.css.
export const CHART_COLORS = [
  "hsl(327, 72%, 42%)", // primary  (pink)
  "hsl(64, 53%, 46%)", // accent   (yellow-green)
  "hsl(181, 57%, 42%)", // success  (teal)
  "hsl(8, 75%, 58%)", // coral
  "hsl(327, 72%, 55%)", // primary lighter
  "hsl(220, 14%, 50%)", // muted slate
];

// Generic dashboard card with optional title/description.
export function Card({ title, description, children, className = "" }) {
  return (
    <article className={"funder-card " + className}>
      {(title || description) && (
        <header className="funder-card-header">
          {title && <h2 className="funder-card-title">{title}</h2>}
          {description && <p className="funder-card-desc">{description}</p>}
        </header>
      )}
      <div className="funder-card-body">{children}</div>
    </article>
  );
}

// Page header (h1 + subtitle) — used at the top of every funder page.
export function PageHeader({ title, description }) {
  return (
    <header className="funder-pageHeader">
      <h1 className="funder-pageTitle">{title}</h1>
      {description && <p className="funder-pageSubtitle">{description}</p>}
    </header>
  );
}

// Compact KPI tile used in the headline grids. `Icon` is a lucide icon
export function StatCard({ icon: Icon, title, value, description, trend }) {
  return (
    <div className="funder-stat">
      <div className="funder-stat-head">
        <span className="funder-stat-title">{title}</span>
        {Icon && <Icon className="funder-stat-icon" aria-hidden="true" />}
      </div>
      <div className="funder-stat-value">{value}</div>
      {(description || trend) && (
        <div className="funder-stat-meta">
          {trend && (
            <span
              className={
                "funder-stat-trend " +
                (trend.isPositive
                  ? "funder-stat-trend-up"
                  : "funder-stat-trend-down")
              }
            >
              {trend.isPositive ? "▲" : "▼"} {trend.value}%
            </span>
          )}
          {description && (
            <span className="funder-stat-desc">{description}</span>
          )}
        </div>
      )}
    </div>
  );
}
